import {
	PROF, REQUESTING,
} from '../constants';
import Errors from '../errors';
import {
	requestError
} from './error';
import firebaseAdaptor from '../firebaseAdaptor';

const db = firebaseAdaptor.db;
const storage = firebaseAdaptor.storage;

export const uploadProfileImage = (image,profileId,onSuccess,OnRequest,onError) =>{
	storage.ref(`profiles/${profileId}`).put(image).on('state_changed',(snapshot)=>{
		//progress
		const progress = Math.round((snapshot.bytesTransferred/snapshot.totalBytes));
		OnRequest && OnRequest(progress);
	},(error)=>{
		//error
		onError && onError(error,Errors.UploadImageFailed);
	},()=>{
		//completed
		try{
			storage.ref('profiles').child(profileId).getDownloadURL()
				.then((url)=>{
					onSuccess(url);
				})
				.catch((error)=>{
					console.error(error);
					//error
					onError && onError(error,Errors.DownloadImageFailed);
				});
		}catch(error){
			console.error(error);
			onError && onError(error,Errors.DownloadImageFailed);
		}
		
	});
};

export function loadProfileForReducer(data){
	return{
		type:PROF.READ_PROFILE,
		payload:{
			...data,
			fetchingState : REQUESTING.LOADED
		}
	};
}

export function registProfile(nextAction){
	return (dispatch, getState) => {
		const {auth} = getState();
		db.collection('profiles').add({
			uid: auth.uid,
			userName : auth.userName,
		})
			.then(nextAction)
			.catch(function(error) {
				dispatch(requestError(PROF.ADD_PROFILE,error,Errors.AddProfileFailed));
			});
	};
}
export function initProfile(dispatch){
	dispatch({
		type : PROF.INIT_PROFILE,
		payload : {
			fetchingState : REQUESTING.LOADED
		}
	});
}
// todo refactor
export function loadProfile(nextAction){
	return (dispatch, getState) => {
		const {auth} = getState();
		db.collection('profiles')
			.where('uid', '==', auth.uid)
			.get()
			.then(function(querySnapshot){
				if(querySnapshot.size===0){
					nextAction(null);
					return;
				}
				const data = {
					id : querySnapshot.docs[0].id,
					...querySnapshot.docs[0].data()
				};
				nextAction(data);
			})
			.catch(function(error){
				dispatch(requestError(PROF.READ_PROFILE,error,Errors.NotFoundProfile));
			});
		dispatch({
			type:PROF.READ_PROFILE,
			payload : {
				fetchingState : REQUESTING.FETCHING
			}
		});
	};
}

export function updateProfile(value,profileId){
	return (dispatch) => {
		db.collection('profiles').doc(profileId).set(value, {merge: true} )
			.then(function(){
				dispatch(loadProfile((data)=>{
					dispatch(loadProfileForReducer(data));
				}));
			})
			.catch(function(error){
				dispatch(requestError(PROF.UPDATE_PROFILE,error,Errors.UpdateProfileFailed));
			});
	};
}

export function updateFavs(recipeId,remove=false){
	return (dispatch,getState) => {
		const {profileReducer} = getState();
		const {id,favs} = profileReducer;
		if(remove){
			const favs2 = favs ? favs.filter(i=>i!==recipeId) : [];
			dispatch(updateProfile({favs:favs2},id));
		}
		else{
			if(favs&&favs.find(i=>recipeId===i)){
				return;
			}
			const favs2 = favs ? [recipeId,...favs] : [recipeId];
			dispatch(updateProfile({favs:favs2},id));
		}
	};
}